import React, { useState, useRef, useEffect} from "react";

import {BackHandler, View, Text, TextInput}  from 'react-native';

import {useNavigation} from '@react-navigation/native'

import {estilos} from '../util/estilos'

import * as util from '../util/util'

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import Botao from '../componentes/Botao'

import {semDados} from '../componentes/SemDados'

import {buscarSubcategorias, removerSubcategoria, novaSubcategoria as wsNovaSubcategoria} from '../ws/ws_subcategorias'

import {ITEM_TIPO_PRODUTO, ITEM_TIPO_SERVICO, MSG_ERRO_PADRAO, TELA_PRINCIPAL} from '../util/constantes'

import cores from '../util/cores'

import RotuloErro from '../componentes/RotuloErro'

import * as texto from '../util/texto'

import Combo from '../componentes/Combo'

import {buscarCategorias as wsBuscarCategorias} from '../ws/ws_categorias'

import Bloco from '../componentes/Bloco'

import Scroll from '../componentes/Scroll'

import Alerta from '../componentes/Alerta'




export default function TelaSubcategorias(){
   
   
	const navegacao = new useNavigation();
	
	const [tipo, setTipo] = useState(ITEM_TIPO_PRODUTO)
	const [categoria, setCategoria] = useState(null)
	
	const [novaNome, setNovaNome] = useState(null)
	const [novaTags, setNovaTags] = useState(null)
	const [msgErro, setMsgErro] = useState(null)
	const [msgPesquisa, setMsgPesquisa] = useState("Clique em buscar para listar as Subcategorias")

	const [lista, setLista] = useState([])
	
	const [listaCategorias, setListaCategorias] = useState([])
	
	const [criando, setCriando] = useState(false)
	
	const blockBackRef = useRef(false);
	
	const btSalvarRef = useRef();
	
	const btPesquisarRef = useRef();
	
	const cbCategoriaRef = useRef();
	
	const dadosTipos = [{'id': ITEM_TIPO_PRODUTO, 'nome': "Produto"}, 
							{'id': ITEM_TIPO_SERVICO, 'nome': "Serviço"}];	
	

	
	useEffect(() => {

		BackHandler.addEventListener('hardwareBackPress', voltar);

		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};
	}, []);
	
	
	function voltar(){
		
		util.print("voltar");
		
		if(blockBackRef.current == true){
			
			util.print("voltar criando");
			
			setMsgErro(null);
			
			setCriando(false);
			
			blockBackRef.current = false;
		}
		else
			navegacao.replace(util.processaVoltar())
		
		return true;		
	}
	
	useEffect(() => {buscarCategorias(tipo)}, []);
	
	
	const buscarDados= async ()=>{
		
		setMsgErro(null);
	
		if(tipo ==null){

            setMsgErro("Selecione o tipo.");
            return;
        } 
		
		if(categoria == null){

            setMsgErro("Selecione a categoria.");
            return;
        }
		
		btPesquisarRef.current.setCarregando(true)
		
		let aux = await buscarSubcategorias(categoria.id);
		
		if(util.temConteudo(aux))
			setLista(aux)
		else{
			
			setLista([]);
			setMsgPesquisa("Nenhuma Subcategoria encontrada");
			
		}
		
		btPesquisarRef.current.setCarregando(false)
	}


	const preparaParaExcluir= async (item)=>{
	
		util.print("preparaParaExcluir "+item.id);

		Alerta("Exclusão de Subcategoria" , "Deseja realmente excluir esta subcategoria?", async () => excluir(item.id));
	}
	
	
	const excluir= async (id)=>{
	
		util.print("excluir "+id);
	
		await removerSubcategoria(id);
		
		buscarDados();
	}


	const novaSubcategoria= ()=>{
	
		setMsgErro(null);
	
		if(categoria == null){

            setMsgErro("Selecione a categoria.");
            return;
        }
		
		setNovaNome(null);
		
		setNovaTags(null);
		
		setCriando(true);
		
		blockBackRef.current = true
	}


	async function salvar(){
		
		btSalvarRef.current.setCarregando(true)
        
		setMsgErro(null);
	
		if(categoria ==null){

            salvarErro("Selecione a categoria.");
            return;
        } 
		
		if(texto.isBlanck(novaNome)){

            salvarErro("Informe o nome da subcategoria.");
            return;
        }
		
		let aux  = await wsNovaSubcategoria(categoria.id, novaNome, novaTags);
		
		if(aux == null || aux.id ==null){
                
			salvarErro(MSG_ERRO_PADRAO);
            return; 
        }

		btSalvarRef.current.setCarregando(false)
        
		setCriando(false);
		
		blockBackRef.current = false
		
		buscarDados();
    }


	function salvarErro(mensagem){
		
        btSalvarRef.current.setCarregando(false);
		setMsgErro(mensagem);
    }


	async function mudouTipo(novoTipo){
		
		util.print("mudouTipo "+novoTipo);
		
		setTipo(novoTipo)
		
		setCategoria(null)

		setLista([])

		await buscarCategorias(novoTipo)
	}


	async function buscarCategorias(tipo){
		
		util.print("buscarCategorias");
		
		if(cbCategoriaRef.current){
			
			cbCategoriaRef.current.setCarregando(true)
			
			let lista = await wsBuscarCategorias(tipo);
			
			if(util.temConteudo(lista)){
			
				setListaCategorias(lista)
				
				cbCategoriaRef.current.setDados(lista, categoria!=null?categoria.id:null);
			}
			else{
				
				setListaCategorias([])
				
				cbCategoriaRef.current.setDados([]);
			}
			
			cbCategoriaRef.current.setCarregando(false)
		}
	}


	function formularioPesquisa(){
		
		return (
			<View style={{flex:1}}>  
				<Bloco podeRecolher={true}>   
					<View style={{marginTop:10}}/>	
					
					<Combo 
						mostrarVazio = {false}
						rotulo="Tipo:"
						dados={dadosTipos} 
						aoMudar={(valor)=>mudouTipo(valor.id)}
						selecionado={tipo}/>

					
					<View style={{marginTop:10}}/>
					
					<Combo 
						rotulo="Categoria:" 
						selecionado={categoria!=null?categoria.id:null} 
						dados={listaCategorias} 
						aoMudar={(valor)=>setCategoria(valor)} 
						ref={cbCategoriaRef}/>
						
					<View style={{marginTop:10}}/>

					{util.temConteudo(msgErro) && 
						<View style={{alignItems:'center'}}>
							<View style={{marginTop:10}}/>
							<RotuloErro mensagem={msgErro}/>
						</View>
					}
				
					<View style={{marginTop:10}}/>
					
					<View style={{alignItems:'center'}}>
						<Botao 
							acao={()=>buscarDados()}
							texto="Buscar Subcategorias"
							ref={btPesquisarRef}/>    
					</View>
				</Bloco>
						
				<View style={{alignItems:'center'}}>
					<Botao 
						acao={()=>novaSubcategoria()}
						texto="Nova Subcategoria"/> 
					<View style={{marginTop:10}}/>	
				</View>
						
				{(util.temConteudo(lista))?
					(lista.map((item, index) => itemLista(item, index))):
					(<Bloco todaArea={true}> 
						<View style={{marginTop:10}}/>
							{semDados("info", msgPesquisa, 60)}
						<View style={{marginTop:10}}/>	
					</Bloco>)
				}					
			</View>	
		)
	}


	function itemLista(item, index){
		
		return (
			<Bloco key={index}> 
				<View style={{marginTop:10}}/>  
				<Text style={estilos.rotulo_titulo}>{item.nome}</Text>
				{util.temConteudo(item.tags) && <Text style={estilos.rotulo_padrao}>{item.tags}</Text>}
				<View style={{marginTop:10}}/>
				
				<View style={{alignItems:'flex-end'}}>
					<Botao
						acao={()=>preparaParaExcluir(item)}
						texto="Excluir"
						somente_texto={true}
						cor={cores.vermelho}/> 
				</View>
				
				<View style={{marginTop:5}}/>
			</Bloco>)
	}


	function formularioCriando(){
		
		return (
			<Bloco todaArea={true}>  
				<View style={{marginTop:20}}/>	
				
				<View style={{alignItems:'center'}}>
					<Text style={estilos.rotulo_titulo}>Nova SubCategoria</Text>
				</View>
				
				<View style={{marginTop:30}}/> 
				
				<Text style={estilos.rotulo_padrao}>Categoria: {categoria.tipo==ITEM_TIPO_PRODUTO?"Produtos":"Serviços"} - {categoria.nome}</Text>
				
				<View style={{marginTop:30}}/> 
				
				<Text style={estilos.rotulo_padrao}>Nome:</Text>
							
				<TextInput
					placeholder=""
					style={estilos.campo_padrao} 
					multiline={false}
					onChangeText={(text)=>setNovaNome(text)}
					maxLength={150}
					value={novaNome}/>
				
				<View style={{marginTop:30}}/> 
								
				<Text style={estilos.rotulo_padrao}>Tags (Opcional):</Text>
							
				<TextInput
					placeholder=""
					style={estilos.campo_padrao} 
					multiline={false}
					onChangeText={(text)=>setNovaTags(text)}
					maxLength={150}
					value={novaTags}/>
				
				<View style={{marginTop:30}}/> 

				<View style={{alignItems:'center'}}>
					<RotuloErro mensagem={msgErro}/>
				</View>
				
				<View style={{marginTop:30}}/>
				
				<View style={{alignItems:'center'}}>
					<Botao 
						acao={()=>salvar()}
						texto="Salvar"
						ref={btSalvarRef}/>    
				</View>
			</Bloco>
		)
	}


	return (
		<ViewDegradeVertical titulo="Subcategorias" voltar={()=>voltar()}>
			<Scroll> 	
				{(criando)?
					(formularioCriando()):
					(formularioPesquisa())
				}	
			</Scroll>
		</ViewDegradeVertical>	
	);

}